import { connect } from "react-redux";
import Calendar from "./Calendar.jsx";
import { fetchDetailsAction, fetchDetailsCloseAction } from "./calendarActions";
import { markClassificationSportsmen } from "../Results/MarkedSportsen/markSportsmenActions";
import { resetSportsmenReducer } from "../Results/MarkedSportsen/markedSportsmenReducer";

const mapStateToProps = (state) => {
  return {
    ...state.calendar,
    gameId: state.games.current && state.games.current.id,
    marked: state.markedSportsmen.sportsmen,
    sportId: state.games.current && state.games.current.sportId,
    gameType: state.games.current && state.games.current.gameType,
    rankingClassificationId: state.ranking.result && state.ranking.result.rankingClassificationId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClick: (gameId, matchId) => dispatch(fetchDetailsAction(gameId, matchId)),
    onDetailsClick: (sportsmenId) => {
      dispatch(resetSportsmenReducer());
      dispatch(markClassificationSportsmen(sportsmenId));
    },
    onDetailsClose: () => dispatch(fetchDetailsCloseAction()),
  };
};

const CalendarContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Calendar);

export default CalendarContainer;
